/**
 * Oracle Guide on Side button for video.js control bar.
 *
 * Follows the VideoOverlayButton pattern for consistency.
 */

const { videojs } = window
const Button = videojs.getComponent('Button')

export const BUTTON_COMPONENT_NAME = 'OracleGuideOnSideButton'

/**
 * Button to toggle Oracle Guide on Side panel
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 */
export class OracleGuideOnSideButton extends Button {
  constructor (player, options) {
    super(player, options)
    this.controlText('AI Guide')
  }

  // eslint-disable-next-line class-methods-use-this
  buildCSSClass () {
    return 'vjs-control vjs-button vjs-oracle-guide-button icon-v2 icon-v2--sherpa'
  }

  handleClick () {
    const { options_ } = this
    if (options_.onOpenGuide) {
      options_.onOpenGuide()
    }
  }
}

export default OracleGuideOnSideButton
